/* Iconic Trading Cards — theme JS */
(function () {
  'use strict';

  /* ---------- Sticky header shadow ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('[data-nav-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- Close desktop dropdowns on outside click ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.header-nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------- Search overlay + predictive search ---------- */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      searchOverlay.classList.add('is-open');
      var input = searchOverlay.querySelector('input[type="search"]');
      window.setTimeout(function () { input && input.focus(); }, 50);
    });
  });
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) searchOverlay.classList.remove('is-open');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') searchOverlay.classList.remove('is-open');
    });
    var searchInput = searchOverlay.querySelector('input[type="search"]');
    var resultsEl = searchOverlay.querySelector('[data-predictive-results]');
    var debounce;
    if (searchInput && resultsEl) {
      searchInput.addEventListener('input', function () {
        window.clearTimeout(debounce);
        var q = searchInput.value.trim();
        if (q.length < 2) { resultsEl.innerHTML = ''; return; }
        debounce = window.setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var results = (data.resources && data.resources.results) || {};
              var collections = (results.collections || []).slice(0, 3).map(function (c) {
                return '<a href="' + c.url + '">' +
                  '<span class="pr-title">📦 ' + c.title + '</span>' +
                  '<span class="pr-price">Collection</span></a>';
              });
              var products = (results.products || []).map(function (p) {
                var img = p.featured_image && p.featured_image.url
                  ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '';
                return '<a href="' + p.url + '">' + img +
                  '<span class="pr-title">' + p.title + '</span>' +
                  '<span class="pr-price">' + p.price + '</span></a>';
              });
              resultsEl.innerHTML = collections.concat(products).join('');
            })
            .catch(function () { /* silent */ });
        }, 220);
      });
    }
  }

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
    var next = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + delta);
    // A max is set where stock is finite (singles) — never step past it.
    if (input.max) next = Math.min(next, parseInt(input.max, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerOverlay = document.querySelector('[data-cart-overlay]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawerOverlay && drawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawerOverlay && drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (!drawer) return; // fall through to /cart link
      e.preventDefault();
      refreshDrawer().then(openDrawer);
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });
  drawerOverlay && drawerOverlay.addEventListener('click', closeDrawer);

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawer && sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          var fresh = tmp.querySelector('[data-cart-drawer]');
          if (fresh) drawer.innerHTML = fresh.innerHTML;
          bindDrawerEvents();
        }
        return updateCartCount();
      });
  }

  function updateCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  function bindDrawerEvents() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    drawer.querySelectorAll('[data-line-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.getAttribute('data-line-remove'), 0);
      });
    });
    drawer.querySelectorAll('[data-line-qty] input').forEach(function (input) {
      input.addEventListener('change', function () {
        var lineMax = parseInt(input.max, 10);
        var wanted = parseInt(input.value, 10) || 0;
        if (lineMax && wanted > lineMax) { wanted = lineMax; input.value = lineMax; }
        changeLine(input.getAttribute('data-line-key'), wanted);
      });
    });
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:changed'));
      refreshDrawer();
    });
  }
  bindDrawerEvents();

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput && qtyInput.max === '0') return;   // stock already fully in the basket
      var btn = form.querySelector('[type="submit"]');
      var orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-adding-text') || 'Adding…';
      // Ticked extras (snippets/product-addons.liquid) go in the same call, one
      // of each per unit of the product, so the basket gets them together.
      var addonBoxes = form.querySelectorAll('[data-addon-variant]:checked');
      var request = { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) };
      if (addonBoxes.length) {
        var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
        var items = [{ id: Number(form.querySelector('[name="id"]').value), quantity: qty }];
        addonBoxes.forEach(function (box) {
          items.push({ id: Number(box.getAttribute('data-addon-variant')), quantity: qty });
        });
        request.headers['Content-Type'] = 'application/json';
        request.body = JSON.stringify({ items: items });
      }
      fetch('/cart/add.js', request)
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw j; });
          return r.json();
        })
        .then(function () {
          btn.textContent = btn.getAttribute('data-added-text') || 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:changed'));
          refreshDrawer().then(openDrawer);
        })
        .catch(function (err) {
          btn.textContent = (err && err.description) ? err.description : 'Unavailable';
        })
        .finally(function () {
          window.setTimeout(function () {
            btn.disabled = false;
            btn.textContent = orig;
            document.dispatchEvent(new CustomEvent('cart:changed'));
          }, 1800);
        });
    });
  });

  /* ---------- Mystery pack offer beside the checkout button ----------
     Delegated from document, not bound per button: this offer renders inside
     the cart drawer, and refreshDrawer() replaces that markup wholesale after
     every cart change — anything bound directly to the button would be dead
     the moment the basket updated once.

     The drawer is deliberately NOT opened afterwards. The customer is already
     at the checkout button; sliding a panel over it to confirm a £4 add is a
     good way to lose the order that was about to happen. The button reports in
     place and the totals refresh underneath. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pack-add]');
    if (!btn) return;
    var id = btn.getAttribute('data-pack-add');
    if (!id || btn.disabled) return;

    var box = btn.closest('[data-pack-offer]');
    var done = box && box.querySelector('[data-pack-done]');
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function () {
        if (done) done.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:changed'));
        refreshDrawer();
        // On the cart page the line items are server-rendered, so the basket
        // has to be re-read to show the pack that was just added.
        if (window.location.pathname === '/cart') window.location.reload();
      })
      .catch(function (err) {
        btn.textContent = (err && err.description) ? err.description : 'Unavailable';
      })
      .finally(function () {
        window.setTimeout(function () { btn.disabled = false; btn.textContent = orig; }, 1600);
      });
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-src');
        main.srcset = '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  });

  /* ---------- In-stock toggle ---------- */
  var STOCK_PARAM = 'filter.v.availability';
  var stockToggles = document.querySelectorAll('[data-stock-toggle]');
  function stockSaved() {
    try { return localStorage.getItem('iconic-instock') === '1'; } catch (e) { return false; }
  }
  function stockSave(on) {
    try { localStorage.setItem('iconic-instock', on ? '1' : '0'); } catch (e) { /* private mode */ }
  }
  if (stockToggles.length) {
    var serverToggles = [].filter.call(stockToggles, function (t) { return t.getAttribute('data-stock-toggle') === 'server'; });
    var clientToggles = [].filter.call(stockToggles, function (t) { return t.getAttribute('data-stock-toggle') === 'client'; });

    /* Twin mode (singles): swap between a collection and its in-stock twin.

       Shopify ignores filter.v.availability as soon as the URL carries a tag
       path, and on singles every character search is one
       (/collections/singles/character-pikachu). The toggle therefore did
       nothing at all on those pages — same products, same count. The twin is a
       smart collection ruled on inventory, and tag paths work on it normally,
       so "in stock" composes with a character and with a set. Liquid works out
       the pieces; this only assembles them. */
    var twinToggles = [].filter.call(stockToggles, function (t) { return t.getAttribute('data-stock-toggle') === 'twin'; });
    if (twinToggles.length) {
      var twinT = twinToggles[0];
      var d = function (name) { return twinT.getAttribute('data-stock-' + name) || ''; };
      var twinOn = window.location.pathname.indexOf(d('twin')) === 0;

      var twinTags = function (withSet) {
        var tags = [];
        if (withSet && d('settag')) tags.push(d('settag'));
        if (d('tags')) tags = tags.concat(d('tags').split('+'));
        return tags.filter(Boolean);
      };

      var twinGo = function (on) {
        stockSave(on);
        var qs = new URLSearchParams(window.location.search);
        qs.delete('page');   // back to page 1 when the result set changes
        qs.delete(STOCK_PARAM);
        var dest;
        if (on) {
          // The set this page is lives on the products as a tag, so it rides
          // along and the swap does not silently widen to every set.
          var tags = twinTags(true);
          dest = d('twin') + (tags.length ? '/' + tags.join('+') : '');
          var home = d('home');
          if (home && home !== d('base')) qs.set('back', home);
        } else {
          // Prefer the page we came from: it has the set name in the title and
          // its own copy, which the tag-path equivalent does not.
          var back = qs.get('back');
          qs.delete('back');
          if (back && /^\/collections\/[A-Za-z0-9+\-\/]*$/.test(back)) {
            dest = back;
          } else {
            var offTags = twinTags(false);
            dest = d('base') + (offTags.length ? '/' + offTags.join('+') : '');
          }
        }
        var q = qs.toString();
        window.location.href = dest + (q ? '?' + q : '');
      };

      twinToggles.forEach(function (t) {
        t.checked = twinOn;
        t.addEventListener('change', function () { twinGo(t.checked); });
      });
      if (twinOn) stockSave(true);
      else if (stockSaved()) twinGo(true);
    }

    /* Server mode (everything else): reload with Shopify's availability filter
       so pagination and counts rebuild around in-stock products only. */
    if (serverToggles.length) {
      var params = new URLSearchParams(window.location.search);
      var path = window.location.pathname;
      var urlOn = params.get(STOCK_PARAM) === '1';
      serverToggles.forEach(function (t) { t.checked = urlOn; });
      if (urlOn) stockSave(true);

      var navigateStock = function (on) {
        var p = new URLSearchParams(window.location.search);
        p.delete('page'); // back to page 1 when the result set changes
        stockSave(on);
        if (on) p.set(STOCK_PARAM, '1'); else p.delete(STOCK_PARAM);
        var qs = p.toString();
        window.location.href = path + (qs ? '?' + qs : '');
      };
      serverToggles.forEach(function (t) {
        t.addEventListener('change', function () { navigateStock(t.checked); });
      });
      if (!urlOn && stockSaved()) navigateStock(true);
    }

    /* Client mode (search results): hide out-of-stock cards on the page. */
    if (clientToggles.length) {
      var applyStock = function (on) {
        document.body.classList.toggle('hide-oos', on);
        clientToggles.forEach(function (t) { t.checked = on; });
        stockSave(on);
      };
      clientToggles.forEach(function (t) {
        t.addEventListener('change', function () { applyStock(t.checked); });
      });
      if (stockSaved()) applyStock(true);
    }
  }

  /* Preserve active query filters when the sort dropdown submits its GET form */
  document.querySelectorAll('.collection-toolbar form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var keep = new URLSearchParams(window.location.search);
      keep.forEach(function (value, key) {
        if (key === 'sort_by' || key === 'page') return;
        if (!form.querySelector('input[name="' + key + '"]')) {
          var h = document.createElement('input');
          h.type = 'hidden'; h.name = key; h.value = value;
          form.appendChild(h);
        }
      });
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();

/* ---------- Hero card river (Oct 2026) ----------
   The river's images carry data-src so they never compete with the real hero
   for bandwidth. One second after window "load" this swaps them in, waits for
   the first few to arrive, then fades the river in. Skipped entirely when the
   visitor has Save-Data on. Paused whenever the hero is off screen. */
(function () {
  var river = document.querySelector('[data-hero-river]');
  if (!river) return;
  var hero = river.closest('.hero');
  var conn = navigator.connection || {};
  if (conn.saveData) return;

  function start() {
    var imgs = Array.prototype.filter.call(river.querySelectorAll('img[data-src]'), function (img) {
      // Columns hidden on phones (display:none) have no offsetParent: leave them unloaded.
      return img.offsetParent !== null;
    });
    var loaded = 0, shown = false, small = window.innerWidth <= 860;
    function show() { if (!shown) { shown = true; river.classList.add('is-on'); } }
    imgs.forEach(function (img) {
      img.addEventListener('load', function () {
        if (img.naturalWidth / img.naturalHeight > 0.9) img.parentNode.classList.add('is-square');
        if (++loaded >= Math.min(10, imgs.length)) show();
      }, { once: true });
      // Phone columns are 84px wide, so 160px images are plenty (2x for retina).
      var src = img.getAttribute('data-src');
      img.src = small ? src.replace('width=240', 'width=170') : src;
      img.removeAttribute('data-src');
    });
    // Never leave the river invisible because one image is slow.
    setTimeout(show, 2500);
  }
  function later() { setTimeout(start, 1000); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });

  if ('IntersectionObserver' in window && hero) {
    new IntersectionObserver(function (entries) {
      hero.classList.toggle('is-paused', !entries[0].isIntersecting);
    }).observe(hero);
  }
})();

/* ---------- Showcase strip (Oct 2026) ----------
   Drifts the product row sideways. The row is a native scroller, so a
   visitor can always swipe or tab through it; the drift stops while they
   hover, touch or focus it, and picks up again a moment after they let go.
   The tiles are cloned once (hidden from screen readers, out of the tab
   order) so the loop can wrap seamlessly at the halfway point. */
(function () {
  var strips = document.querySelectorAll('[data-showcase-strip]');
  if (!strips.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  strips.forEach(function (strip) {
    var vp = strip.querySelector('[data-strip-viewport]');
    var belt = strip.querySelector('[data-strip-belt]');
    if (!vp || !belt || belt.children.length < 3) return;

    Array.prototype.slice.call(belt.children).forEach(function (li) {
      var c = li.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      belt.appendChild(c);
    });

    var SPEED = 28;            // px per second
    var pos = vp.scrollLeft, last = 0, held = false, visible = true, resumeAt = 0, raf = 0;

    function half() { return belt.scrollWidth / 2; }
    function tick(t) {
      raf = requestAnimationFrame(tick);
      var dt = last ? Math.min(t - last, 64) / 1000 : 0;
      last = t;
      if (held || !visible || document.hidden || t < resumeAt) { pos = vp.scrollLeft; return; }
      pos += SPEED * dt;
      if (pos >= half()) pos -= half();
      vp.scrollLeft = pos;
    }
    function hold() { held = true; }
    function release() { held = false; resumeAt = performance.now() + 2500; }

    vp.addEventListener('pointerenter', hold);
    vp.addEventListener('pointerleave', release);
    vp.addEventListener('touchstart', hold, { passive: true });
    vp.addEventListener('touchend', release, { passive: true });
    vp.addEventListener('focusin', hold);
    vp.addEventListener('focusout', release);
    // A swipe that carries past the clones wraps back, so it never runs out.
    vp.addEventListener('scroll', function () {
      if (held && vp.scrollLeft >= half()) vp.scrollLeft -= half();
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(strip);
    }
    raf = requestAnimationFrame(tick);
  });
})();

/* ---------- "Watch our story" dialog (Oct 2026) ----------
   The video only gets its src on first open, so it costs nothing until
   someone asks for it. Closing (button, Esc, or a click on the backdrop)
   pauses it; reopening carries on from where they left off. */
(function () {
  var dlg = document.querySelector('[data-story-dialog]');
  var open = document.querySelector('[data-story-open]');
  if (!dlg || !open || typeof dlg.showModal !== 'function') return;
  var video = dlg.querySelector('video');
  open.addEventListener('click', function () {
    if (!video.getAttribute('src')) video.src = video.getAttribute('data-src');
    dlg.showModal();
    var p = video.play(); if (p && p.catch) p.catch(function () {});
  });
  dlg.querySelector('[data-story-close]').addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener('close', function () { video.pause(); open.focus(); });
})();
